<template>
  <li class="nav-item nav-item-register">
    <a class="nav-link nav-link-login" @click="modalAuthDialog()">
      <i class="fas fa-sign-in-alt"></i> {{ $t('account.nav.login') }}
    </a>
  </li>
</template>

<script>
import AuthDialog from '@account/js/components/modals/AuthDialog'
export default {
  name: 'AuthComponent',
  title: '',
  props: {
    service: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {}
  },
  computed: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    modalAuthDialog() {
      this.$modal.show(
        AuthDialog,
        {
          id: this.service.id,
          modal: true,
        },
        {
          name: 'auth-modal',
          clickToClose: false,
          resizable: false,
          adaptive: true,
          draggable: false,
          scrollable: true,
          height: 'auto',
          maxWidth: 780,
          width: '100%',
          transition: 'nice-modal-fade',
        },
      )
    },
  },
}
</script>
